<template>
  <v-container class="pt-0 pb-6">
    <chart :options="option"/>
  </v-container>
</template>

<script>
import ECharts from "vue-echarts"
import moment from "moment"
export default {
  components: {
    chart: ECharts,
  },
  data() {
    return {
      option: {},
    };
  },
  watch: {
    dataChart(val) {
      this.chartLine(val)
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null
      const [year, month] = date.split('-')
      return `/${month}/${year}`
    },
    chartLine(val) {
      let operadora = this.dataChart.operadora ? this.dataChart.operadora : 'TODAS AS OPERADORAS'
      let length = val.periodo1.length > val.periodo2.length? val.periodo1.length: val.periodo2.length
      let date1 = val.data_referencia1[0].split('T')[0]
      let date2 = val.data_referencia2[0].split('T')[0]

      let d1 = ''
      let d2 = ''
      let semana
      let legend = []
      if (length <= 7) {
        semana = true
        legend = [ "Seg",  "Ter", "Qua", "Qui", "Sex", "Sab", "Dom" ]
      } else {
        semana = false
        d1 = this.formatDate(date1)
        d2 = this.formatDate(date2)
        for (let i = 1; i <= length; i++) {
          legend.push(i)
        }  
      }
      const formatTootip = function(data){
        let legend = 
        `<div style="border-radius:4px;width:100%;height:auto;background-color:#ffffffd1;border:1px solid #D7DCE6;padding:8px;box-shadow: 0px 1px 8px rgba(215, 220, 230, 0.2), 0px 3px 4px rgba(215, 220, 230, 0.12), 0px 3px 3px rgba(215, 220, 230, 0.14);">
         <span style="color:#4A4A4A;font-weight:600;font-size:12px;margin-botton:2px;">${operadora}</span>
         <br/>${semana? data[0] && data[0].value!= undefined ? data[0].name+'<br/>'+moment(val.data_referencia1[data[0].dataIndex]).format('DD/MM/YYYY')+'<br/>' : data[0].name+'<br/>' : (data[0] && data[0].value!=undefined?data[0].name+d1+'<br/>': '')}
         ${data[0] && data[0].value!= undefined? data[0].marker+' '+data[0].value: ''}
         <br/>${semana? data[1] && data[1].value!= undefined ? moment(val.data_referencia2[data[1].dataIndex]).format('DD/MM/YYYY')+'<br/>' : '<br/>' : (data[1]?data[1].name+d2+'<br/>': '')}
         ${data[1] && data[1].value!= undefined? data[1].marker+' '+data[1].value: ''}
         </div>`
        return legend
      }

      this.option = {
        tooltip: {
          trigger: 'axis',
            backgroundColor: 'none',
          axisPointer: {
            type: 'line',
            animation: true,
          },
          formatter:(data)=> formatTootip(data),
          textStyle : {
            color: '#4A4A4A',
            fontWeight: '600',
            fontSize: 12,
          }
        },
        title: {
          subtext: `${operadora} | Solicitações por período`,
          top: "-5%",
          left: "2%",
          color: "#4A4A4A",
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '0%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            interval: 0,
            textStyle: {
              color: "#4A4A4A",
              fontSize: 10,
            },
          },
          type: "category",
          data: legend
        },
        yAxis: {
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#4A4A4A",
            },
          },
          splitLine: {
            lineStyle: {
              color: "#4a4a4a08",
            },
          },
          type: "value",
        },
        color: ["#035A27", "#31B1FF"],
        series: [
          { 
            type: "line",
            smooth: true, 
            data: val.periodo1 
          },
          { 
            type: "line", 
            smooth: true,
            data: val.periodo2
          },
        ],
        animationDuration: 2000
      }
    },
  },
  props: {
    dataChart: Object,
  },
};
</script>

<style scoped>
.echarts {
  width: 100%;
  height: 300px;
}

.name-operador {
  margin-left: 25px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 21px;
  letter-spacing: 0.53px;
  color: #4a4a4a;
}

.label-month {
  margin-left: 40%;
}
</style>